/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/study-svt.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from 'views/pages/admin/audit-log/service';
import { stringDateWithoutTimeFromUtc } from '@utils/convertor';

const propArray = ['CfId'];

const StudySvtRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const enums: any = {
        LeadUnit: AuditEnumValues.StudyTimeUnit,
        MinWinUnit: AuditEnumValues.StudyTimeUnit,
        MaxWinUnit: AuditEnumValues.StudyTimeUnit,
    };

    const associations: any = {
        CohortIds: {
            itemField: 'cohorts',
            name: 'Cohort',
            nameResolver: (cohort: any) => cohort.name,
        },
        TreatmentArmIds: {
            itemField: 'treatmentArms',
            name: 'Treatment Arm',
            nameResolver: (arm: any) => arm.name,
        },
        VisitIds: {
            itemField: 'visits',
            name: 'Visit',
            nameResolver: (visit: any) => visit.visitName,
        },
    };

    const refactoredOldRecord = {
        ...oldRecord,
        ...removePropertiesFromObject(oldRecord, propArray),
        VersionDate: stringDateWithoutTimeFromUtc(oldItem?.versionDate?.time, 'DD-MMM-YYYY'),
        CfId: oldRecord.CfId?.$oid,
    };

    const refactoredNewRecord = {
        ...newRecord,
        ...removePropertiesFromObject(newRecord, propArray),
        VersionDate: stringDateWithoutTimeFromUtc(newItem?.versionDate?.time, 'DD-MMM-YYYY'),
        CfId: newRecord.CfId?.$oid,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, undefined, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field, enums, associations }),
    );

    return <FieldChangeGrid items={items} />;
};
export { StudySvtRecordChangeGrid };
